module.exports = __webpack_public_path__ + "img/20160410_2188.69dd4e04.jpeg";